import { render } from "./about.vue?vue&type=template&id=3ca19182&scoped=true&bindings={\"topImg\":\"data\",\"leftnavIcon1\":\"data\",\"leftnavIcon2\":\"data\",\"questionIcon1\":\"data\",\"questionIcon2\":\"data\",\"changeContent\":\"data\",\"doubtIcon\":\"data\",\"emailIcon\":\"data\"}"
import script from "./about.vue?vue&type=script&lang=js"
export * from "./about.vue?vue&type=script&lang=js"

import "./about.vue?vue&type=style&index=0&id=3ca19182&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-3ca19182"

export default script